import { AdditionalFieldWithLabel } from "@boark/shared/types/additional-field";

import { useLocale } from "../stores/locale";
import { Checkbox } from "./checkbox";
import { Input } from "./input";
import { Select } from "./select";

export function AdditionalFields({
  disabled = false,
  additionalFields,
  onChange,
  values,
}: {
  disabled?: boolean;
  additionalFields: AdditionalFieldWithLabel[];
  onChange: (values: Record<string, string>) => void;
  values: Record<string, string>;
}) {
  return (
    <>
      {additionalFields.map((additionalField) => (
        <AdditionalFieldToInput
          key={additionalField.name}
          disabled={disabled}
          {...additionalField}
          value={values[additionalField.name] ?? ""}
          onChange={(value) =>
            onChange({ ...values, [additionalField.name]: value })
          }
        />
      ))}
    </>
  );
}

function AdditionalFieldToInput({
  disabled = false,
  label,
  type,
  options,
  required,
  value,
  onChange,
}: AdditionalFieldWithLabel & {
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
}) {
  const t = useLocale((state) => state.locale);

  if (type === "text" || type === "number" || type === "date") {
    return (
      <Input
        disabled={disabled}
        label={label}
        required={required}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  } else if (type === "select") {
    return (
      <Select
        allowEmpty={!required}
        disabled={disabled}
        label={label}
        options={options ?? []}
        placeholder={t.select.placeholder}
        value={value}
        onChange={(value) => onChange(value)}
      />
    );
  } else if (type === "boolean") {
    return (
      <>
        <Checkbox
          checked={value === "1"}
          className="flex pt-4 items-center gap-2"
          disabled={disabled}
          label={label}
          onClick={() => {
            onChange(value === "1" ? "0" : "1");
          }}
        />
      </>
    );
  }
}
